import EHouse from '@/images/energypal-icons/e-house-5.png';
import BestExperience from '@/images/energypal-icons/solar-project-experts-5.png';
import BestPrices from '@/images/energypal-icons/check-badge-icon.png';
import PanelIcon from '@/images/all-plans/panel-icon.png';
import Image from 'next/legacy/image';
import SmartLink from '../Button/SmartLink';
import Link from 'next/link';

const features = [
  {
    name: 'Your trusted advisor',
    description:
      'We listen, educate, and advise.  EnergyPal is an unbiased service to assist you in shopping for the best-fit energy solution for your home.',
    icon: EHouse,
  },
  {
    name: 'Free custom designs',
    description:
      'Your dedicated Advisor will work with you to design solar systems to meet your home needs, and compare programs side-by-side!',
    icon: PanelIcon,
  },
  {
    name: 'Better products & prices',
    description:
      'Save more, get more with EnergyPal. Rest easy knowing we secured wholesale prices for you on top-quality equipment & warranties.',
    icon: BestPrices,
  },
  {
    name: 'Stress-free experience',
    description:
      'Our personalized service is the easiest way to switch to solar energy with confidence. Don’t believe it? Read our EnergyPal solar reviews!',
    icon: BestExperience,
  },
];

export default function GetTheEnergyPalAdvantage() {
  return (
    <div className="pt-16 pb-20 bg-white">
      <div className="max-w-xl px-4 mx-auto sm:px-6 lg:max-w-6xl lg:px-8">
        {/* <h2 className="sr-only">EnergyPal Advantage</h2> */}
        <h2 className="mt-2 text-3xl font-bold tracking-tight text-center text-gray-900 sm:text-4xl">
          Get the EnergyPal advantage
        </h2>
        <p className="mt-4 text-lg text-center text-gray-900">
          Along with top quality energy products, you get even more shopping
          with{' '}
          <Link className="text-primary underline" href={'/'}>
            EnergyPal.
          </Link>{' '}
          <SmartLink href="/compare">See more solar benefits.</SmartLink>
        </p>
        <dl className="grid-cols-1 mt-10 space-y-10 lg:space-y-0 lg:grid lg:grid-cols-2 lg:gap-x-32 lg:gap-y-12">
          {features.map((feature) => (
            <div key={feature.name}>
              <dt>
                <div className="flex items-center w-12 h-12 rounded-md text-primary">
                  <Image src={feature.icon} alt={feature.name} />
                  {/* <feature.icon className="w-10 h-10" aria-hidden="true" /> */}
                </div>
                <p className="mt-5 text-2xl font-bold leading-6 text-gray-900 capitalize">
                  {feature.name}
                </p>
              </dt>
              <dd className="mt-2 text-base text-gray-500">
                {feature.description}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
